import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBirthdayCake: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconBirthdayCake"><Path fillRule="evenodd" clipRule="evenodd" d="M12.0003 0.757324L14.1216 2.87864C15.2932 4.05022 15.2932 5.94971 14.1216 7.12129C13.794 7.44886 13.4096 7.68484 13 7.82924V8.99997H20.5V15.677L20 15.877V22H4V15.877L3.5 15.677V8.99997H11V7.82902C10.5907 7.68461 10.2064 7.4487 9.87898 7.12129C8.70741 5.94971 8.70741 4.05022 9.87898 2.87864L12.0003 0.757324ZM5.5 11V14.3229L7 14.9229L9.5 13.9229L12 14.9229L14.5 13.9229L17 14.9229L18.5 14.3229V11H5.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBirthdayCake;
